import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

type SttButtonCloseProps = {
    fullWidth?: boolean;
    onClick: () => void;
    textColor?: string;
};

/**
 * Close button
 */
export function SttButtonClose({
    fullWidth,
    onClick,
    textColor = 'inherit',
}: SttButtonCloseProps) {
    const { t } = useTranslation();

    return (
        <Button
            fullWidth={fullWidth}
            variant="outlined"
            color="inherit"
            startIcon={<CloseIcon />}
            onClick={onClick}
            sx={{ color: textColor }}
        >
            {t('ui.close')}
        </Button>
    );
}
